export default __webpack_public_path__ + "static/media/rox-upi.f66e0ab4.png";